import { useAuth } from '@/hooks/useAuth';
import { can, canAll } from '@/lib/auth/permissions';
import type { PermissionKey } from '@/lib/constants/permissions';

/**
 * Whether the current session holds an entity permission (AUTHZ-1). Use to gate
 * feature UI: `const canManageTeam = usePermission(PERMISSIONS.TEAM_MANAGE)`.
 */
export function usePermission(permission: PermissionKey): boolean {
  return can(useAuth().user, permission);
}

/**
 * Check several permission keys in one call, e.g. for rendering a row of
 * toggles/columns each gated by a different key.
 */
export function usePermissions(
  permissions: readonly PermissionKey[],
): Record<PermissionKey, boolean> {
  return canAll(useAuth().user, permissions);
}
